<template>
  <v-speed-dial
    v-model="fab"
    direction="right"
    fixed
    left
    bottom
    transition="slide-x-transition"
    style="z-index:9;"
  >
    <template v-slot:activator>
      <v-btn v-model="fab" color="blue darken-2" dark fab>
        <v-icon v-if="fab">mdi-close</v-icon>
        <v-icon v-else>mdi-book-outline</v-icon>
      </v-btn>
    </template>
    <v-btn fab dark small color="green" title="Stampa etichette" @click="stampaEtichette">
      <v-icon>mdi-card-bulleted-outline</v-icon>
    </v-btn>
    <v-btn fab dark small color="indigo" title="Stampa documenti" @click="stampaDocumenti">
      <v-icon>mdi-printer</v-icon>
    </v-btn>
<!--     <v-btn fab dark small color="red">
      <v-icon>mdi-card-bulleted-outline</v-icon>
    </v-btn> -->
  </v-speed-dial>
</template>

<script>
export default {
  data() {
    return {
      fab: false
    }
  },
  methods: {
    stampaEtichette() {
      this.$emit('comando', 'stampa-etichette')
    },
    stampaDocumenti() {
      this.$emit('comando', 'stampa-documenti')
    }
  }
}
</script>